import { useFormikContext } from 'formik';

// import { useClinicalNoteContext } from 'lib/context/ClinicalNoteContext/ClinicalNoteContext';
// import { useMacrosContext } from 'lib/context/MacrosContext/MacrosContext';
// import { iaRa, io } from 'lib/helpers/utility';

// import { getTypeOfNotes } from 'components/practice/charts/ClinicalNote/MyScribeAI/lib/helpers';
// import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';

// import Typography from 'components/shared/Typography/Typography';

// import FormSelect from '../FormSelect/FormSelect';
// import FormsList from '../FormsList';
// import NoteSelect from '../NoteSelect';

const NoteMacroForm = () => {
  const { values, errors, setFieldValue } = useFormikContext();

  // const { cnDisplaySettings, advancedHP, advancedSOAP, customFormTypes } = useClinicalNoteContext();

  // const { activeMacro } = useMacrosContext();

  // const selectFormsHandler = (note, form, checked) => {
  //   const prev = values?.body?.forms;

  //   const newData = [...iaRa(prev?.[note])];

  //   if (checked) {
  //     newData.push(form);
  //   } else {
  //     const index = newData.findIndex((item) => item === form);
  //     if (index > -1) {
  //       newData.splice(index, 1);
  //     }
  //   }

  //   const newValue = { [note]: newData };

  //   setFieldValue('body', { forms: newValue });
  // };

  // const selectNoteHandler = (note) => {
  //   setFieldValue('note', note);
  // };

  // const typeOfNotes = getTypeOfNotes({
  //   cnDisplaySettings,
  //   advancedHP,
  //   advancedSOAP,
  //   customFormTypes
  // });

  // const forms = values?.body?.forms;
  // const note = values?.note;

  // const hasForms = io(forms) && Object.values(forms?.[note?.value] || {}).flat().length;

  return (
    <>
      <div className="flex w-full flex-wrap gap-4">
        <Input
          className="flex-1"
          id="note-macro-input-name"
          label="Note Macro Name"
          data-qa="enter-note-template-label"
          placeholder="Enter note macro name"
          name="name"
          autoComplete="off"
          value={values?.name}
          onChange={(event) => setFieldValue('name', event.target.value)}
          required={true}
          error={errors?.name}
        />

        {/* <div className="flex w-full gap-x-4">
          <div className="basis-1/2">
            <NoteSelect selectHandler={selectNoteHandler} value={values?.note} />
          </div>
          <div className="basis-1/2">
            <FormSelect
              isButton={false}
              noteType={note?.value}
              selectedItems={forms}
              selectHandler={selectFormsHandler}
            />
          </div>
        </div> */}
      </div>

      {/* <>
          <div className="my-6 h-px bg-neutral-100"></div>
          {hasForms ? (
            <FormsList selectedForms={forms} typeOfNotes={typeOfNotes} className="pb-[200px]" />
          ) : (
            <div>
              <div className="flex w-full flex-col items-center justify-center gap-y-1">
                <Icon icon="illustration-choose-enhance-note" className="mb-6" />
                <Typography variant="label" size="large" color="primary-900">
                  Select a note type and forms to create a note macro.
                </Typography>
                <Typography color="neutral-600">
                  After selecting, the forms will be rendered here.
                </Typography>
              </div>
            </div>
          )}
        </> */}
    </>
  );
};

export default NoteMacroForm;
